// Data Lab · field provenance model (Module 06 §2).
// Four classes drive hide/surface behaviour + completeness bars + health checks.
//   bc  = BigCommerce-derived (empty is acceptable → hide when empty)
//   crm = Talmia CRM / enrichment (empty is an ACTIONABLE GAP → always show)
//   ai  = AI enrichment output (_ai_*) (show status even when absent)
//   sys = IDs / sync / pipeline linkage (diagnostic → hide when empty)
// Editable here without a deploy.

export const PERSON_PROVENANCE = {
  // crm — the job. Always surfaced, even empty.
  AccountManager: "crm", CompanySummary: "crm", Website: "crm", CompanyNumber: "crm",
  CreditCheck: "crm", CreditLimit: "crm", CompaniesHouseURL: "crm",
  LinkedinURL: "crm", Facebook: "crm", Instagram: "crm",
  Notes: "crm", Activities: "crm",
  // bc — contact / address / order aggregates.
  Email: "bc", Phone: "bc", FirstName: "bc", LastName: "bc", FullName: "bc", Company: "bc",
  Addresses: "bc", City: "bc", State: "bc",
  PostCode: "bc", Postcode: "bc", Country: "bc", BCCustGroupId: "bc",
  NumberOfOrders: "bc", NumberOfRegOrders: "bc", NumberOfGuestOrders: "bc",
  TotalOrdersValue: "bc", AverageOrderValue: "bc", FirstOrderDate: "bc", LastOrderDate: "bc",
  Data8Errors: "bc",
  // sys — identity / linkage / metadata.
  _id: "sys", PersonId: "sys", PipelineId: "sys", StageId: "sys", DealId: "sys",
  DealTitle: "sys", OrgId: "sys", ShortVIPLevel: "sys", LongVIPLevel: "sys",
  BCCustIds: "sys", OrderIds: "sys", Names: "sys", Companies: "sys",
  UpdatedDate: "sys", _received_at: "sys", _source: "sys",
};

// CRM enrichment targets destined for the Customer 360 brain (Module 06 §7).
export const CRM_ENRICHMENT_FIELDS = [
  { key: "AccountManager", label: "Account Manager" },
  { key: "CompanySummary", label: "Company summary" },
  { key: "CompanyNumber", label: "Company number" },
  { key: "CompaniesHouseURL", label: "Companies House" },
  { key: "CreditCheck", label: "Credit check" },
  { key: "CreditLimit", label: "Credit limit" },
  { key: "Website", label: "Website" },
  { key: "LinkedinURL", label: "LinkedIn" },
  { key: "Facebook", label: "Facebook" },
  { key: "Instagram", label: "Instagram" },
];

export const PROV_LABEL = { bc: "BigC", crm: "CRM", ai: "AI", sys: "Sys" };
export const PROV_TONE = {
  bc: { color: "#5eead4", bg: "rgba(45,212,191,0.12)", border: "rgba(45,212,191,0.35)" },
  crm: { color: "#e0a94f", bg: "rgba(224,169,79,0.12)", border: "rgba(224,169,79,0.35)" },
  ai: { color: "#c4b5fd", bg: "rgba(167,139,250,0.12)", border: "rgba(167,139,250,0.35)" },
  sys: { color: "#94a3b8", bg: "rgba(148,163,184,0.10)", border: "rgba(148,163,184,0.30)" },
};

export function provClass(field, map = PERSON_PROVENANCE) {
  return map[field] || "sys";
}
